"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Number = exports.IframeStyle = exports.IFrameContainer = exports.BadgeContainer = void 0;
var _uiKit = require("@icis/ui-kit");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _WidthWrapper = require("../../../../../../WidthWrapper");
var _sharedStyles = require("../../../../sharedStyles");
// istanbul ignore file

const {
  colours
} = _uiKit.theme;
const Number = exports.Number = _styledComponents.default.span.withConfig({
  displayName: "styles__Number",
  componentId: "sc-119ouex-0"
})(["font-size:9px;"]);
const BadgeContainer = exports.BadgeContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__BadgeContainer",
  componentId: "sc-119ouex-1"
})(["height:18px;width:fit-content;min-width:20px;background-color:", ";border-radius:50%;color:white;text-align:center;position:absolute;z-index:20;right:0;top:8px;padding:4px;display:flex;justify-content:center;align-items:center;pointer-events:none;:empty{display:none;}@media only screen and (max-width:1300px){right:6px;}"], colours.WARNING);
const IframeStyle = exports.IframeStyle = _styledComponents.default.iframe.withConfig({
  displayName: "styles__IframeStyle",
  componentId: "sc-119ouex-2"
})(["border:none;"]);
const IFrameContainer = exports.IFrameContainer = _styledComponents.default.div.withConfig({
  displayName: "styles__IFrameContainer",
  componentId: "sc-119ouex-3"
})(["background-color:", ";position:fixed;", " width:362px;height:calc(100vh - ", "px);z-index:10;top:", "px;box-shadow:10px 10px 12px rgba(174,174,192,0.251147),-4px 0 12px rgba(0,0,0,0.0956075);"], colours.NEUTRALS_6, () => {
  if (window.innerWidth > _WidthWrapper.widthVariantLookup.NORMAL) {
    return (0, _styledComponents.css)(["right:calc((100% - ", "px) / 2 + 24px);"], _WidthWrapper.widthVariantLookup.NORMAL);
  }
  return (0, _styledComponents.css)(["right:24px;"]);
}, _sharedStyles.headerHeight, _sharedStyles.headerHeight);